import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const externalTaxServiceConfigSchema = serviceConfigSchema;
// ============================================================================
// DTO Schema
// ============================================================================
const externalTaxServiceConfigDtoSchema = serviceConfigSchema;

export { externalTaxServiceConfigDtoSchema, externalTaxServiceConfigSchema };
//# sourceMappingURL=ExternalTaxServiceConfig.js.map
